import { encodeQuestionQuery, QuestionQuery } from '@/services/api/resources/question/query';
import { pipe } from 'fp-ts/function';
import {
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createGetRequest,
  decode,
  fetchApi,
  jsonHeaders,
  setBody,
  setQuery,
} from '@/services/api';
import { chain, map } from 'fp-ts/TaskEither';
import { questionListCodec } from '@/services/api/resources/question';
import { FormItemFilterPayload } from '@/entities/question';
import { formItemFilterCodec } from '@/services/api/resources/analytics-builder/codec';

const analyticsUrl = '/v2/analytics/filters/form-items';
const publicAnalyticsUrl = (report: number, id: string): string =>
  `/v2/public/analytics/filters/${report}/form-item/${id}`;

export const list = (query: QuestionQuery) => pipe(
  '/v2/inspections/questions',
  createAuthorizedGetRequest,
  map(setQuery(encodeQuestionQuery(query))),
  chain(fetchApi),
  chain(decode(questionListCodec)),
);

export const analyticsFilterList = (payload: FormItemFilterPayload) => pipe(
  analyticsUrl,
  createAuthorizedPostRequest,
  map(setBody(payload)),
  chain(fetchApi),
  chain(decode(formItemFilterCodec)),
);

export const analyticsFilterGet = (id: string) => pipe(
  `${analyticsUrl}/${id}`,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(formItemFilterCodec)),
);

export const publicAnalyticsFilterGet = (reportId: number, id: string) => pipe(
  publicAnalyticsUrl(reportId, id),
  jsonHeaders(createGetRequest),
  fetchApi,
  chain(decode(formItemFilterCodec)),
);
